import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import ProjectService from "../services/ProjectService";
import ProjectItemService from "../services/ProjectItemService";
import ItemCategoryService from "../services/ItemCategoryService";
import ItemsService from "../services/ItemsServices";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import Loading from "../components/loading";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import ReactPaginate from "react-paginate";
import MessageDialog from "../components/MessageDialog";
import * as XLSX from "xlsx-js-style";
import utility from "../utils/utility";

export default function AddProjectItems() {
    const [projects, setProjects] = useState([]);
    const [items, setItems] = useState([]);
    const [itemCategories, setItemCategories] = useState([]);
    const [allItemCategories, setAllItemCategories] = useState([]);

    const [showCategoryFilterDropdown, setShowCategoryFilterDropdown] = useState(false);
    const [categoryFilterSearch, setCategoryFilterSearch] = useState("");
    const categoryFilterRef = useRef(null);

    const [assignedList, setAssignedList] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState("");
    // const [tableSearch, setTableSearch] = useState("");
    const [itemFilter, setItemFilter] = useState("");
    const [categoryFilter, setCategoryFilter] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const [categorySearch, setCategorySearch] = useState("");
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const categoryDropdownRef = useRef(null);
    const [selectedItems, setSelectedItems] = useState([]);
    // messages
    const [pageMessage, setPageMessage] = useState("");
    const [pageMsgType, setPageMsgType] = useState("error");
    const [modalMessage, setModalMessage] = useState("");
    const [modalMsgType, setModalMsgType] = useState("error");



    const [editData, setEditData] = useState(null);
    const [selected, setSelected] = useState(null);

    // Item search
    const [itemSearch, setItemSearch] = useState("");
    const [showItemDropdown, setShowItemDropdown] = useState(false);
    const itemDropdownRef = useRef(null);

    const { register, reset, getValues, setValue } = useForm();
    const companyId = StorageService.activeCompany().companyId;
    const login = StorageService.loginData();

    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    const showPageMessage = (msg, type = "error") => {
        setPageMessage(msg);
        setPageMsgType(type);
        // setTimeout(() => setPageMessage(""), 3000);
    };

    const { permission, checkView, can } = usePermission(
        ScreenData.Project_Items,
        showPageMessage
    );
    // -------------------------------
    // Load Initial Data
    // -------------------------------
    // useEffect(() => {
    //     loadProjects();
    //     loadItemCategories();
    //     // loadAssignedItems();
    //     loadAssignedItemsByCompany();
    // }, []);

    useEffect(() => {
        setSelected(null);
        setEditData(null);
    }, [assignedList, selectedProjectId]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedProjectId, itemFilter, categoryFilter]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                categoryDropdownRef.current &&
                !categoryDropdownRef.current.contains(e.target)
            ) {
                setShowCategoryDropdown(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);



    // const handleStatusToggle = async (row) => {
    //     if (!can("canModify")) {
    //         showPageMessage("No permission");
    //         return;
    //     }
    //     if (loading) return;

    //     try {
    //         setLoading(true);

    //         await ProjectItemService.toggleStatus(row.id);

    //         // Reload correctly
    //         if (selectedProjectId) {
    //             await loadAssignedItemsByProject(selectedProjectId);
    //         } else {
    //             await loadAssignedItemsByCompany();
    //         }
    //     } catch (err) {
    //         showPageMessage("Failed to update status");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleStatusToggle = async (row) => {

        if (!can("canModify")) {
            showPageMessage("No permission");
            return;
        }

        const action =
            row.status === "Active"
                ? "Inactive"
                : "Active";

        const confirmed = window.confirm(
            `Are you sure you want to change the status to ${action}?`
        );

        if (!confirmed) return;

        try {

            setLoading(true);

            await ProjectItemService.toggleStatus(row.id);

            showPageMessage(
                `Status changed to ${action} successfully`,
                "success"
            );

            await loadAssignedItems();

        } catch (err) {

            showPageMessage(
                err?.response?.data?.message ||
                "Failed to update status"
            );

        } finally {
            setLoading(false);
        }
    };


    const loadAssignedItemsByProject = async (projectId) => {
        setLoading(true);
        try {
            const res = await ProjectItemService.getByProjectId(projectId);
            setAssignedList(res?.data?.data || []);
        } catch {
            showPageMessage("Failed to fetch project items");
        } finally {
            setLoading(false);
        }
    };


    const loadProjects = async () => {
        try {
            const res = await ProjectService.getActive(companyId);
            setProjects(res?.data || res || []);
        } catch {
            showPageMessage("Failed to load projects");
        }
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                itemDropdownRef.current &&
                !itemDropdownRef.current.contains(e.target)
            ) {
                setShowItemDropdown(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                categoryFilterRef.current &&
                !categoryFilterRef.current.contains(e.target)
            ) {
                setShowCategoryFilterDropdown(false);
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (editData && (items || []).length > 0) {
            setValue("itemId", editData.itemId);
        }
    }, [items, editData, setValue]);

    // const loadItemCategories = async () => {
    //     try {
    //         const res = await ItemCategoryService.getActive();
    //         console.log("ACTIVE ITEMCategories:", res); // 👈 check this
    //         setItemCategories(Array.isArray(res) ? res : []);
    //     } catch {
    //         showPageMessage("Failed to load active itemCategorues");
    //     }
    // };


    const loadItemCategories = async (projectId = null, currentCategoryId = null) => {
        try {
            // Get all active categories
            const categoryRes = await ItemCategoryService.getActive();

            const allCategories = Array.isArray(categoryRes)
                ? categoryRes
                : [];

            setAllItemCategories(allCategories);

            // If no project is selected, show all categories
            if (!projectId) {
                setItemCategories(allCategories);
                return;
            }

            // Fetch active items across all categories
            let allActiveItems = [];
            try {
                const itemsRes = await ItemsService.getActive();
                allActiveItems = Array.isArray(itemsRes) ? itemsRes : [];
            } catch (err) {
                console.error("Failed to load active items for category validation:", err);
            }

            // Get items already assigned to this project
            const assignedRes =
                await ProjectItemService.getByProjectId(projectId);

            const assignedItems =
                assignedRes?.data?.data ||
                assignedRes?.data ||
                [];

            // Get unique assigned item IDs
            const assignedItemIds = new Set(
                assignedItems.map((item) =>
                    Number(item.itemId)
                )
            );

            // Filter categories:
            // A category is excluded ONLY if it has active items AND every single active item in that category is already assigned to the project.
            // If remaining items exist, show the category.
            // In MODIFY MODE, keep current category.
            const availableCategories = allCategories.filter((category) => {
                const categoryId = Number(category.id);

                if (
                    currentCategoryId &&
                    categoryId === Number(currentCategoryId)
                ) {
                    return true;
                }

                const catItems = allActiveItems.filter(
                    (i) => Number(i.itemCategoryId) === categoryId
                );

                if (catItems.length > 0) {
                    const isFullyAssigned = catItems.every((i) =>
                        assignedItemIds.has(Number(i.id))
                    );
                    if (isFullyAssigned) {
                        return false;
                    }
                }

                return true;
            });

            setItemCategories(availableCategories);

        } catch (error) {
            console.error("Failed to load item categories:", error);
            showPageMessage("Failed to load item categories");
        }
    };

    const loadItems = async (categoryId, projectId = selectedProjectId) => {
        try {
            const res = await ItemsService.getItemByCategoryId(categoryId);
            const categoryItems = Array.isArray(res) ? res : [];

            // In ADD mode (when adding items), exclude items already assigned to this project
            if (projectId && !editData) {
                const assignedRes = await ProjectItemService.getByProjectId(projectId);
                const assigned = assignedRes?.data?.data || assignedRes?.data || [];
                const assignedItemIds = new Set(assigned.map((item) => Number(item.itemId)));

                const unassignedItems = categoryItems.filter(
                    (item) => !assignedItemIds.has(Number(item.id))
                );
                setItems(unassignedItems);
            } else {
                setItems(categoryItems);
            }
        } catch {
            setItems([]);
            showPageMessage("Failed to load active items");
        }
    };

    const handleAddItem = (item) => {
        const exists = selectedItems.find(i => i.itemId === item.id);

        if (!exists) {
            setSelectedItems(prev => [
                ...prev,
                {
                    itemId: item.id,
                    itemCode: item.itemCode,
                    itemDescription: item.itemDescription,
                    uom: item.uomName || item.uomCode || item.uom || "-",
                    minimumShelfQuantity: 0
                }
            ]);
        }
    };

    const displayedCategoryItems = (items || []).filter((i) => {
        if (!itemSearch) return true;
        const search = itemSearch.toLowerCase();
        return (
            (i.itemCode && i.itemCode.toLowerCase().includes(search)) ||
            (i.itemDescription && i.itemDescription.toLowerCase().includes(search))
        );
    });

    const isAllCategoryItemsSelected =
        displayedCategoryItems.length > 0 &&
        displayedCategoryItems.every((i) =>
            selectedItems.some((s) => s.itemId === i.id)
        );

    const handleToggleSelectAllCategoryItems = () => {
        if (isAllCategoryItemsSelected) {
            const displayedIds = new Set(displayedCategoryItems.map((i) => i.id));
            setSelectedItems((prev) => prev.filter((s) => !displayedIds.has(s.itemId)));
        } else {
            setSelectedItems((prev) => {
                const existingMap = new Map(prev.map((s) => [s.itemId, s]));
                displayedCategoryItems.forEach((i) => {
                    if (!existingMap.has(i.id)) {
                        existingMap.set(i.id, {
                            itemId: i.id,
                            itemCode: i.itemCode,
                            itemDescription: i.itemDescription,
                            uom: i.uomName || i.uomCode || i.uom || "-",
                            minimumShelfQuantity: 0,
                            isDashboard: 0,
                        });
                    }
                });
                return Array.from(existingMap.values());
            });
        }
    };

    const handleToggleSingleItem = (item) => {
        setSelectedItems((prev) => {
            const exists = prev.some((s) => s.itemId === item.id);
            if (exists) {
                return prev.filter((s) => s.itemId !== item.id);
            } else {
                return [
                    ...prev,
                    {
                        itemId: item.id,
                        itemCode: item.itemCode,
                        itemDescription: item.itemDescription,
                        uom: item.uomName || item.uomCode || item.uom || "-",
                        minimumShelfQuantity: 0,
                        isDashboard: 0,
                    },
                ];
            }
        });
    };

    const handleQuantityChange = (itemId, qty) => {
        setSelectedItems((prev) =>
            prev.map((item) => {
                if (item.itemId === itemId) {
                    return { ...item, minimumShelfQuantity: qty };
                }
                return item;
            })
        );
    };

    const handleDashboardToggle = (itemId, checked) => {
        setSelectedItems((prev) =>
            prev.map((item) => {
                if (item.itemId === itemId) {
                    return { ...item, isDashboard: checked ? 1 : 0 };
                }
                return item;
            })
        );
    };

    const handleMainDashboardToggle = async (row) => {
        try {
            const newDashboardVal = (row.isDashboard === 1 || row.isDashboard === true || row.userField1 === "1" || row.userField1 === 1) ? 0 : 1;
            const updatePayload = {
                companyId,
                projectId: row.projectId,
                itemCategoryId: row.itemCategoryId,
                itemId: row.itemId,
                minimumShelfQuantity: row.minimumShelfQuantity || 0,
                isDashboard: newDashboardVal,
                status: row.status || "Active",
                updatedBy: login.employeeId,
            };
            await ProjectItemService.update(row.id, updatePayload);
            loadAssignedItems();
        } catch (err) {
            showPageMessage("Failed to update dashboard visibility");
        }
    };


    // const loadAssignedItems = async () => {
    //     setLoading(true);
    //     try {
    //         const res = await ProjectItemService.getAll(
    //             companyId,
    //             currentPage,
    //             itemsPerPage,
    //             null,
    //             null,
    //             tableSearch,
    //             selectedProjectId
    //         );
    //         setAssignedList(res?.data?.data || []);
    //         setPageCount(res?.data?.pagination?.totalPages || res?.pagination?.totalPages || 1);
    //     } catch {
    //         showPageMessage("Failed to fetch project items");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const loadAssignedItems = async () => {
        setLoading(true);

        try {
            const res = await ProjectItemService.getAll(
                companyId,
                currentPage,
                itemsPerPage,
                null,
                null,
                "",
                selectedProjectId,
                itemFilter,
                categoryFilter
            );

            setAssignedList(res?.data?.data || []);

            setPageCount(
                res?.data?.pagination?.totalPages ||
                res?.pagination?.totalPages ||
                1
            );

        } catch (error) {
            console.error(error);
            showPageMessage("Failed to fetch project items");

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (permission && checkView()) {
            loadProjects();
            loadItemCategories();
        }
    }, [permission]);



    // useEffect(() => {
    //     if (permission && checkView()) {
    //         loadAssignedItems();
    //     }
    // }, [currentPage, selectedProjectId, tableSearch, permission]);

    useEffect(() => {
        if (permission && checkView()) {
            loadAssignedItems();
        }
    }, [
        currentPage,
        selectedProjectId,
        itemFilter,
        categoryFilter,
        permission
    ]);

    //   const loadAssignedItems = async () => {
    //     setLoading(true);
    //     try {
    //       const res = await ProjectItemService.getAll();
    //       setAssignedList(res?.data?.data || []);
    //     } catch {
    //       showPageMessage("Failed to fetch project items");
    //     } finally {
    //       setLoading(false);
    //     }
    //   };

    // -------------------------------
    // Helpers
    // ------------------------------

    const showModalMessage = (msg, type = "danger") => {
        setModalMessage(msg);
        setModalMsgType(type);
        // setTimeout(() => setModalMessage(""), 3000);
    };

    const filteredAssignedList = assignedList.filter((row) => {
        if (row.companyId !== companyId) return false;
        if (selectedProjectId && row.projectId !== selectedProjectId) return false;
        return true;
    });

    const normalize = (str = "") =>
        str.toLowerCase().replace(/[^a-z0-9]/g, "");

    const filteredItems =
        itemSearch.length >= 3
            ? items.filter((i) => {
                const search = normalize(itemSearch);
                const code = normalize(i.itemCode);
                const desc = normalize(i.itemDescription);

                return code.includes(search) || desc.includes(search);
            })
            : [];

    // -------------------------------
    // Add / Modify
    // -------------------------------
    // const handleAddBtn = () => {
    //     if (!can("canAdd")) {
    //         showPageMessage("No permission");
    //         return;
    //     }
    //     setPageMessage("");
    //     setEditData(null);
    //     setSelected(null); // ✅ clear old selection

    //     if (!selectedProjectId) {
    //         showPageMessage("Select a project to add", "danger");
    //         return;
    //     }

    //     setCategorySearch("");
    //     setItems([]);
    //     setSelectedItems([]);
    //     setItemSearch("");
    //     setValue("itemCategoryId", "");

    //     reset({ itemId: "" });
    //     setShowModal(true);
    // };

    const handleAddBtn = async () => {
        if (!can("canAdd")) {
            showPageMessage("No permission");
            return;
        }

        setPageMessage("");
        setEditData(null);
        setSelected(null);

        if (!selectedProjectId) {
            showPageMessage("Select a project to add", "danger");
            return;
        }

        setCategorySearch("");
        setItems([]);
        setSelectedItems([]);
        setItemSearch("");
        setValue("itemCategoryId", "");

        reset({ itemId: "" });

        // Load only categories NOT already assigned
        await loadItemCategories(selectedProjectId);

        setShowModal(true);
    };

    const selectedProject = projects.find(
        (p) => p.id === (editData?.projectId || selectedProjectId)
    );



    const handleModify = async () => {
        if (!can("canModify")) {
            showPageMessage("No permission");
            return;
        }
        setPageMessage("");
        // if (!selectedProjectId) {
        //     showPageMessage("Select a project to modify", "info");
        //     return;
        // }

        if (!selected) {
            showPageMessage("Please select a record to modify");
            return;
        }

        const row = assignedList.find((r) => r.id === selected);
        if (!row) {
            showPageMessage("Selected record not found", "danger");
            return;
        }

        // const selectedProject = projects.find(
        //   (p) => p.id === (selectedProjectId || editData?.projectId)
        // );

        const qty = row.minimumShelfQuantity ?? row.minimumshelfquantity ?? 0;

        setSelectedItems([
            {
                itemId: row.itemId,
                itemCode: row.itemCode,
                itemDescription: row.itemDescription,
                uom: row.uomName || row.uomCode || row.uom || "-",
                minimumShelfQuantity: qty,
                isDashboard: (row.isDashboard === 1 || row.isDashboard === true || row.userField1 === "1" || row.userField1 === 1) ? 1 : 0
            }
        ]);

        // setSelectedProjectId(row.projectId);
        setEditData(row);
        console.log("row data..", row);
        // Show selected item in input
        setItemSearch(`${row.itemCode} --- ${row.itemDescription}`);
        // setValue("itemCategoryId", row.itemCategoryId);
        // setCategorySearch(row.itemCategoryName);
        // loadItems(row.itemCategoryId);

        setValue("itemCategoryId", row.itemCategoryId);
        setCategorySearch(row.itemCategoryName);

        // Load categories for modify mode
        await loadItemCategories(row.projectId, row.itemCategoryId);

        loadItems(row.itemCategoryId);

        // IMPORTANT: DO NOT reset form here
        // setValue("itemId", row.itemId);

        setShowModal(true);
    };

    const getProjectFullName = (row) => {
        const project = projects.find(p => p.id === row.projectId);
        return `${project?.projectName || row.projectName}${project?.projectCode ? " - " + project.projectCode : ""
            }`;
    };

    // -------------------------------
    // Save / Update
    // -------------------------------
    const handleSave = async () => {
        if (!editData && !can("canAdd")) {
            showModalMessage("No permission");
            return;
        }

        if (editData && !can("canModify")) {
            showModalMessage("No permission");
            return;
        }
        const data = getValues();

        if (!selectedItems || selectedItems.length === 0) {
            showModalMessage("⚠ Please select at least one item");
            return;
        }

        setLoading(true);
        console.log("data for edit.", data);
        // 🔥 IMPORTANT FIX
        const payload = {
            companyId,
            projectId: selectedProjectId || editData?.projectId,
            itemCategoryId: data.itemCategoryId,
            // itemId: data.itemId,
            items: selectedItems,
            status: "Active",
            updatedBy: login.employeeId,
        };

        // ✅ Only include projectId if selected
        if (selectedProjectId) {
            payload.projectId = selectedProjectId || editData?.projectId;
        }

        try {
            if (editData) {
                const singleItem = selectedItems[0]; // only one in edit mode

                const updatePayload = {
                    companyId,
                    projectId: selectedProjectId || editData?.projectId,
                    itemCategoryId: data.itemCategoryId,
                    itemId: singleItem.itemId,
                    minimumShelfQuantity: singleItem.minimumShelfQuantity,
                    isDashboard: singleItem.isDashboard ? 1 : 0,
                    status: "Active",
                    updatedBy: login.employeeId,
                };

                await ProjectItemService.update(editData.id, updatePayload);
            } else {
                payload.projectId = selectedProjectId; // required for create
                payload.createdBy = login.employeeId;
                await ProjectItemService.create(payload);
            }

            showModalMessage("Saved successfully!", "success");

            setTimeout(() => {
                setShowModal(false);
                setEditData(null);
                setSelected(null);

                setCategorySearch("");
                setItems([]);
                setSelectedItems([]);
                setItemSearch("");
                setValue("itemCategoryId", "")
                reset({ itemId: "" });

                loadAssignedItems();
            }, 500);
        } catch (err) {
            showModalMessage(err.response?.data?.message || "Internal server error");
        } finally {
            setLoading(false);
        }
    };

    // ===== EXCEL EXPORT FUNCTION =====
    const handleExportToExcel = async () => {
        try {
            // Check if project is selected
            if (!selectedProjectId) {
                showPageMessage("Please select a project to export", "error");
                return;
            }

            setLoading(true);

            let dataToExport = [];

            try {
                // Fetch all items for the selected project and current filters without page limit
                const res = await ProjectItemService.getAll(
                    companyId,
                    1,
                    100000,
                    null,
                    null,
                    "",
                    selectedProjectId,
                    itemFilter,
                    categoryFilter
                );
                dataToExport = res?.data?.data || res?.data || [];
            } catch (fetchErr) {
                console.error("Failed to fetch all items for export:", fetchErr);
                const res = await ProjectItemService.getByProjectId(selectedProjectId);
                dataToExport = res?.data?.data || res?.data || [];
            }

            if (!dataToExport || dataToExport.length === 0) {
                showPageMessage("No items to export for this project", "error");
                setLoading(false);
                return;
            }

            // Get company and project info
            const activeCompany = StorageService.activeCompany();
            const companyName = activeCompany?.companyName || "Company";
            const selectedProjectData = projects.find(p => p.id === selectedProjectId);
            const projectName = selectedProjectData ? `${selectedProjectData.projectName} - ${selectedProjectData.projectCode}` : "Project";

            const currentDate = new Date();
            const reportDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

            // Create workbook and worksheet
            const workbook = XLSX.utils.book_new();
            const worksheet = {};
            worksheet["!merges"] = [];
            worksheet["!cols"] = [
                { wch: 20 },  // Item Category
                { wch: 25 },  // Item Name
                { wch: 40 },  // Description
                { wch: 15 },  // UOM
                { wch: 15 },  // Min Shelf Qty
                { wch: 15 },  // Dashboard
                { wch: 15 },  // Status
                { wch: 18 },  // H - Report Date
            ];

            let row = 0;

            // Styles
            const companyNameStyle = {
                font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
                alignment: { horizontal: "center", vertical: "center" },
            };

            const reportTitleStyle = {
                font: { bold: true, sz: 14, color: { rgb: "1F4E78" } },
                alignment: { horizontal: "center", vertical: "center" },
            };

            const reportDateStyle = {
                font: { bold: true, sz: 10, color: { rgb: "000000" } },
                alignment: { horizontal: "right", vertical: "center" },
            };

            const headerStyle = {
                fill: { fgColor: { rgb: "4472C4" } },
                font: { bold: true, sz: 11, color: { rgb: "FFFFFF" } },
                alignment: { horizontal: "center", vertical: "center" },
                border: {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" },
                },
            };

            const cellStyle = {
                alignment: { horizontal: "left", vertical: "center" },
                border: {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" },
                },
            };

            // ======================================================
            // HEADER ROW 1
            // Company Name | Project Items | Report Date
            // ======================================================

            // Company Name - A1
            XLSX.utils.sheet_add_aoa(worksheet, [[companyName]], {
                origin: { r: row, c: 0 },
            });

            worksheet[XLSX.utils.encode_cell({ r: row, c: 0 })].s =
                companyNameStyle;


            // ======================================================
            // REPORT TITLE - B1:D1
            // ======================================================

            XLSX.utils.sheet_add_aoa(worksheet, [["Project Items"]], {
                origin: { r: row, c: 1 },
            });

            // Merge B1:D1
            worksheet["!merges"].push({
                s: { r: row, c: 1 },
                e: { r: row, c: 3 },
            });

            // Apply title style
            worksheet[XLSX.utils.encode_cell({ r: row, c: 1 })].s = {
                font: {
                    bold: true,
                    sz: 14,
                    color: { rgb: "1F4E78" }
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center"
                }
            };

            // ======================================================
            // REPORT DATE - Merged E1:F1
            // ======================================================

            // Report Date (Label + Value merged)
            XLSX.utils.sheet_add_aoa(
                worksheet,
                [[`Report Date: ${reportDate}`]],
                {
                    origin: { r: row, c: 4 },
                }
            );

            // Merge E1:F1
            worksheet["!merges"].push({
                s: { r: row, c: 4 },
                e: { r: row, c: 5 },
            });

            worksheet[XLSX.utils.encode_cell({ r: row, c: 4 })].s = {
                font: {
                    bold: true,
                    sz: 10,
                    color: { rgb: "000000" }
                },
                alignment: {
                    horizontal: "right",
                }
            };


            // Move to Row 2
            row += 2;


            // ======================================================
            // FILTER ROW 2 & 3
            // Project | Item Category | Item
            // ======================================================

            // ---------- PROJECT LABEL ----------
            XLSX.utils.sheet_add_aoa(
                worksheet,
                [["Project:"]],
                {
                    origin: { r: row, c: 0 },
                }
            );

            worksheet[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
                font: {
                    bold: true,
                    sz: 11,
                },
                alignment: {
                    horizontal: "left",
                    vertical: "center",
                },
            };


            // ---------- PROJECT VALUE ----------
            const projectDisplayName = selectedProjectData
                ? `${selectedProjectData.projectName}${selectedProjectData.projectCode
                    ? " - " + selectedProjectData.projectCode
                    : ""
                }`
                : "All Projects";

            XLSX.utils.sheet_add_aoa(
                worksheet,
                [[projectDisplayName]],
                {
                    origin: { r: row, c: 1 },
                }
            );

            // Merge B2:C2 so long project names get more space
            worksheet["!merges"].push({
                s: { r: row, c: 1 },
                e: { r: row, c: 2 },
            });

            worksheet[XLSX.utils.encode_cell({ r: row, c: 1 })].s = {
                font: {
                    bold: false,
                    sz: 11,
                },
                alignment: {
                    horizontal: "left",
                    vertical: "center",
                    wrapText: true,
                },
            };


            // ---------- ITEM CATEGORY ----------
            row += 1;

            const selectedCategoryName = categoryFilter
                ? (
                    allItemCategories.find(
                        (category) =>
                            String(category.id) === String(categoryFilter)
                    )?.itemCategoryName || "Selected Category"
                )
                : "All Categories";

            // ---------- ITEM CATEGORY LABEL ----------
            XLSX.utils.sheet_add_aoa(
                worksheet,
                [["Item Category:"]],
                {
                    origin: { r: row, c: 0 },
                }
            );

            worksheet[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
                font: {
                    bold: true,
                    sz: 11,
                },
                alignment: {
                    horizontal: "left",
                    vertical: "center",
                },
            };

            // ---------- ITEM CATEGORY VALUE ----------

            XLSX.utils.sheet_add_aoa(
                worksheet,
                [[selectedCategoryName]],
                {
                    origin: { r: row, c: 1 },
                }
            );

            // Merge B3:C3
            worksheet["!merges"].push({
                s: { r: row, c: 1 },
                e: { r: row, c: 2 },
            });

            worksheet[XLSX.utils.encode_cell({ r: row, c: 1 })].s = {
                font: {
                    bold: false,
                    sz: 11,
                },
                alignment: {
                    horizontal: "left",
                    vertical: "center",
                    wrapText: true,
                },
            };


            // ---------- ITEM LABEL ----------
            XLSX.utils.sheet_add_aoa(
                worksheet,
                [["Item:"]],
                {
                    origin: { r: row, c: 3 },
                }
            );

            worksheet[XLSX.utils.encode_cell({ r: row, c: 3 })].s = {
                font: {
                    bold: true,
                    sz: 11,
                },
                alignment: {
                    horizontal: "left",
                    vertical: "center",
                },
            };


            // ---------- ITEM VALUE ----------
            const itemDisplayValue = itemFilter?.trim() || "All Items";

            XLSX.utils.sheet_add_aoa(
                worksheet,
                [[itemDisplayValue]],
                {
                    origin: { r: row, c: 4 },
                }
            );

            worksheet[XLSX.utils.encode_cell({ r: row, c: 4 })].s = {
                font: {
                    bold: false,
                    sz: 11,
                },
                alignment: {
                    horizontal: "left",
                    vertical: "center",
                    wrapText: true,
                },
            };


            // Move to next row
            row += 1;


            // Empty Row
            row += 1;

            // ===== TABLE HEADERS =====
            const headers = [
                "Item Category",
                "Item Name",
                "Description",
                "UOM",
                "Min Shelf Qty",
                "Dashboard",
                "Status",
            ];

            XLSX.utils.sheet_add_aoa(worksheet, [headers], {
                origin: { r: row, c: 0 },
            });

            // Style header row
            for (let i = 0; i < headers.length; i++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: i });
                if (worksheet[cellAddress]) {
                    worksheet[cellAddress].s = headerStyle;
                }
            }

            row += 1;

            // ===== DATA ROWS =====
            dataToExport.forEach((item) => {
                const isDashboardValue = (item.isDashboard === 1 || item.isDashboard === true || item.userField1 === "1" || item.userField1 === 1) ? "Yes" : "No";

                const rowData = [
                    item.itemCategoryName || "",
                    item.itemCode || "",
                    item.itemDescription || "",
                    item.uomName || item.uomCode || item.uom || "",
                    item.minimumShelfQuantity || item.minimumshelfquantity || 0,
                    isDashboardValue,
                    item.status || "",
                ];

                XLSX.utils.sheet_add_aoa(worksheet, [rowData], {
                    origin: { r: row, c: 0 },
                });

                // Apply cell styling
                for (let i = 0; i < rowData.length; i++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: row, c: i });
                    if (worksheet[cellAddress]) {
                        worksheet[cellAddress].s = cellStyle;
                    }
                }

                row += 1;
            });

            // Column Widths
            worksheet["!cols"] = [
                { wch: 30 }, // Item Category
                { wch: 40 }, // Item Name
                { wch: 30 }, // Description
                { wch: 15 }, // UOM
                { wch: 15 }, // Min Shelf Qty
                { wch: 15 }, // Dashboard
                { wch: 15 }, // Status
            ];

            // Add worksheet to workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, "Project Items");

            // Generate filename
            // const timestamp = new Date().toISOString().slice(0, 10);
            // const filename = `ProjectItems_${selectedProjectData?.projectCode || "Project"}_${timestamp}.xlsx`;

            // Generate filename:
            // ProjectItems_ProjectName_ProjectCategory_DD-MM-YYYY.xlsx

            const safeProjectName = (
                selectedProjectData?.projectName || "Project"
            )
                .replace(/[\\/:*?"<>|]/g, "_")
                .trim();

            const projectCategoryName = (
                selectedProjectData?.projectCategoryName ||
                selectedProjectData?.projectCategory ||
                "ProjectCategory"
            )
                .replace(/[\\/:*?"<>|]/g, "_")
                .trim();

            const filename = `ProjectItems_${safeProjectName}_${projectCategoryName}_${reportDate}.xlsx`;

            // Write file
            XLSX.writeFile(workbook, filename);
            showPageMessage("Excel file exported successfully", "success");
        } catch (err) {
            console.error(err);
            showPageMessage("Error exporting to Excel", "error");
        } finally {
            setLoading(false);
        }
    };


    // -------------------------------
    // JSX
    // -------------------------------
    return (
        <>
            <Breadcrumb pageTitle="Assign Project Items" secondTitle="Projects" />

            <MessageDialog
                message={pageMessage || modalMessage}
                type={
                    (pageMsgType === "success" || modalMsgType === "success")
                        ? "success"
                        : "error"
                }
                setMessage={() => {
                    setPageMessage("");
                    setModalMessage("");
                }}
                setMsgType={() => { }}
            />


            {/* FILTER */}
            <div className="card p-3 mb-3">
                <label className="form-label">Project</label>
                <div className="col-md-6">
                    <select
                        className="form-select"
                        value={selectedProjectId}
                        onChange={(e) => {
                            const pid = Number(e.target.value);
                            setSelectedProjectId(pid);
                            setSelected(null);       // ✅ clear radio
                            setEditData(null);       // ✅ reset edit state
                            setPageMessage("");
                        }}
                    >
                        <option value="">All Project</option>
                        {projects.map((p) => (
                            <option key={p.id} value={p.id}>
                                {p.projectName}-{p.projectCode}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* TABLE */}
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {/* <h5 className="mb-0 me-3">Assigned Items</h5> */}
                        {/* <input
                            type="text"
                            className="form-control"
                            style={{ width: "300px" }}
                            placeholder="Search Category or Item..."
                            value={tableSearch}
                            onChange={(e) => setTableSearch(e.target.value)}
                        /> */}

                        <div className="d-flex align-items-center gap-2">

                            {/* Item Category Filter */}
                            <div
                                className="position-relative"
                                ref={categoryFilterRef}
                                style={{ width: "280px" }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Item Category"
                                    value={
                                        categoryFilter
                                            ? (
                                                allItemCategories.find(
                                                    (c) => String(c.id) === String(categoryFilter)
                                                )?.itemCategoryName || ""
                                            )
                                            : categoryFilterSearch
                                    }
                                    onFocus={() => setShowCategoryFilterDropdown(true)}
                                    onChange={(e) => {
                                        setCategoryFilterSearch(e.target.value);
                                        setCategoryFilter("");
                                        setShowCategoryFilterDropdown(true);
                                    }}
                                />

                                {showCategoryFilterDropdown && (
                                    <div
                                        className="dropdown-menu show w-100 shadow-sm"
                                        style={{
                                            maxHeight: "250px",
                                            overflowY: "auto",
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            zIndex: 1050,
                                        }}
                                    >
                                        {/* All Categories */}
                                        <button
                                            type="button"
                                            className="dropdown-item py-2"
                                            onClick={() => {
                                                setCategoryFilter("");
                                                setCategoryFilterSearch("");
                                                setShowCategoryFilterDropdown(false);
                                            }}
                                        >
                                            All Categories
                                        </button>

                                        {/* Filtered Categories */}
                                        {allItemCategories
                                            .filter((category) =>
                                                category.itemCategoryName
                                                    ?.toLowerCase()
                                                    .includes(categoryFilterSearch.toLowerCase())
                                            )
                                            .map((category) => (
                                                <button
                                                    key={category.id}
                                                    type="button"
                                                    className="dropdown-item py-2"
                                                    onClick={() => {
                                                        setCategoryFilter(category.id);
                                                        setCategoryFilterSearch("");
                                                        setShowCategoryFilterDropdown(false);
                                                    }}
                                                >
                                                    {category.itemCategoryName}
                                                </button>
                                            ))}

                                        {/* No results */}
                                        {allItemCategories.filter((category) =>
                                            category.itemCategoryName
                                                ?.toLowerCase()
                                                .includes(categoryFilterSearch.toLowerCase())
                                        ).length === 0 && (
                                                <div className="dropdown-item text-muted">
                                                    No categories found
                                                </div>
                                            )}
                                    </div>
                                )}
                            </div>

                            {/* Item Filter */}
                            <input
                                type="text"
                                className="form-control"
                                style={{ width: "270px" }}
                                placeholder="Search Item Name..."
                                value={itemFilter}
                                onChange={(e) => setItemFilter(e.target.value)}
                            />

                        </div>

                    </div>

                    <div className="d-flex align-items-center">
                        {can("canAdd") && (
                            <button
                                className="btn btn-success me-2"
                                disabled={loading}
                                onClick={handleAddBtn}
                            >
                                + Add Item
                            </button>
                        )}

                        {can("canModify") && (
                            <button
                                className="btn btn-warning me-2"
                                disabled={loading}
                                onClick={handleModify}
                            >
                                Modify
                            </button>
                        )}

                        <button
                            className="btn btn-info"
                            disabled={loading || !selectedProjectId}
                            onClick={handleExportToExcel}
                            title={selectedProjectId ? "Export project items to Excel" : "Please select a project to export"}
                        >
                            <i className="ti ti-download me-1"></i> Export to Excel
                        </button>

                    </div>
                </div>

                <div className="card-body">
                    {/* {pageMessage && (
                        <div className={`alert alert-${pageMsgType}`}>{pageMessage}</div>
                    )} */}

                    <div className="table-responsive">
                        <table className="table table-bordered align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th style={{ width: "40px" }} className="text-center">#</th>
                                    <th>Project</th>
                                    <th style={{ width: "150px" }}>Item Category</th>
                                    <th style={{ width: "180px" }}>Item Name</th>
                                    <th>Description</th>
                                    <th style={{ width: "100px" }}>UOM</th>
                                    <th style={{ width: "100px" }} className="text-center">Dashboard</th>
                                    <th style={{ width: "90px" }} className="text-center">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="8" className="text-center py-4">
                                            <Loading />
                                        </td>
                                    </tr>
                                ) : assignedList.length ? (
                                    assignedList.map((row) => (
                                        <tr key={row.id}>
                                            <td className="text-center">
                                                <input
                                                    type="radio"
                                                    disabled={loading}
                                                    checked={selected === row.id}
                                                    onChange={() => setSelected(row.id)}
                                                />
                                            </td>
                                            <td>{getProjectFullName(row)}</td>
                                            <td>{row.itemCategoryName}</td>
                                            <td className="fw-semibold text-dark">{row.itemCode}</td>
                                            <td>{row.itemDescription}</td>
                                            <td>{row.uomName || row.uomCode || row.uom || "-"}</td>
                                            <td className="text-center">
                                                <div className="form-check form-switch d-flex justify-content-center align-items-center mb-0">
                                                    <input
                                                        className="form-check-input cursor-pointer"
                                                        type="checkbox"
                                                        checked={row.isDashboard === 1 || row.isDashboard === true || row.userField1 === "1" || row.userField1 === 1}
                                                        onChange={() => handleMainDashboardToggle(row)}
                                                        title="Toggle Dashboard Visibility"
                                                    />
                                                </div>
                                            </td>

                                            <td className="text-center">
                                                <span
                                                    className={`badge ${row.status === "Active"
                                                        ? "bg-success"
                                                        : "bg-danger"
                                                        }`}
                                                    style={{
                                                        cursor: "pointer",
                                                        padding: "8px 12px"
                                                    }}
                                                    onClick={() => handleStatusToggle(row)}
                                                    title="Click to change status"
                                                >
                                                    {row.status}
                                                </span>
                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            No items assigned to this project
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <ReactPaginate
                        // forcePage={currentPage - 1}
                        forcePage={Math.max(0, currentPage - 1)}
                        breakLabel="..."
                        nextLabel="Next >"
                        previousLabel="< Previous"
                        onPageChange={(e) => setCurrentPage(e.selected + 1)}
                        pageCount={pageCount}   // ✅ IMPORTANT
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={2}
                        containerClassName="pagination-container"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeClassName="active"
                    />
                </div>
            </div>

            {/* MODAL */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(15, 23, 42, 0.6)",
                        backdropFilter: "blur(4px)",
                        zIndex: 1050,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "850px",
                            maxHeight: "90vh",
                            background: "#ffffff",
                            borderRadius: "12px",
                            boxShadow: "0 20px 25px -5px rgba(0,0,0,0.15), 0 10px 10px -5px rgba(0,0,0,0.04)",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            zIndex: 1060,
                        }}
                    >
                        {/* Modal Header */}
                        <div
                            className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom"
                            style={{ backgroundColor: "#f8fafc" }}
                        >
                            <div>
                                <h5 className="mb-0 fw-bold text-dark">
                                    {editData ? "Modify Project Item" : "Assign Project Items"}
                                </h5>
                                {selectedProject && (
                                    <small className="text-muted">
                                        Project: <span className="fw-semibold text-primary">{selectedProject.projectName}</span> {selectedProject.projectCode ? `(${selectedProject.projectCode})` : ""}
                                    </small>
                                )}
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => {
                                    setShowModal(false);
                                    setEditData(null);
                                    setSelectedItems([]);
                                    setCategorySearch("");
                                    setItems([]);
                                    setItemSearch("");
                                    setValue("itemCategoryId", "");
                                    reset({ itemId: "" });
                                }}
                            />
                        </div>

                        {/* Modal Body */}
                        <div className="p-4" style={{ overflowY: "auto" }}>
                            {/* Project Field */}
                            <div className="mb-3">
                                <label className="form-label fw-semibold">Selected Project</label>
                                <input
                                    type="text"
                                    className="form-control bg-light fw-bold text-dark"
                                    value={selectedProject ? `${selectedProject.projectName}${selectedProject.projectCode ? " - " + selectedProject.projectCode : ""}` : ""}
                                    readOnly
                                />
                            </div>

                            {/* Item Category Field */}
                            <div className="mb-3 position-relative" ref={categoryDropdownRef}>
                                <label className="form-label fw-semibold">Item Category</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search or select Item Category..."
                                    value={categorySearch}
                                    onChange={(e) => {
                                        setCategorySearch(e.target.value);
                                        setShowCategoryDropdown(true);
                                    }}
                                    onFocus={() => setShowCategoryDropdown(true)}
                                />

                                {showCategoryDropdown && (
                                    <div
                                        className="dropdown-menu show w-100 shadow-sm"
                                        style={{ maxHeight: "200px", overflowY: "auto" }}
                                    >
                                        {itemCategories
                                            .filter((c) =>
                                                c.itemCategoryName
                                                    .toLowerCase()
                                                    .includes(categorySearch.toLowerCase())
                                            )
                                            .map((c) => (
                                                <button
                                                    key={c.id}
                                                    type="button"
                                                    className="dropdown-item py-2"
                                                    onClick={() => {
                                                        setValue("itemCategoryId", c.id);
                                                        setCategorySearch(c.itemCategoryName);
                                                        setShowCategoryDropdown(false);
                                                        setSelectedItems([]);
                                                        setItems([]);
                                                        loadItems(c.id, selectedProjectId || editData?.projectId);
                                                    }}
                                                >
                                                    {c.itemCategoryName}
                                                </button>
                                            ))}
                                    </div>
                                )}
                            </div>

                            {/* Category Items List with Checkboxes & Select All */}
                            {getValues("itemCategoryId") ? (
                                editData ? (
                                    /* Single item modify mode */
                                    <div className="card p-3 border rounded">
                                        <h6 className="fw-semibold text-primary mb-3">Item Details</h6>
                                        {selectedItems.map((item) => (
                                            <div key={item.itemId} className="row g-3 align-items-center">
                                                <div className="col-md-3">
                                                    <label className="form-label text-muted small mb-1">Item Name</label>
                                                    <div className="fw-bold">{item.itemCode}</div>
                                                </div>
                                                <div className="col-md-3">
                                                    <label className="form-label text-muted small mb-1">Description</label>
                                                    <div>{item.itemDescription}</div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label text-muted small mb-1">UOM</label>
                                                    <div className="fw-semibold text-dark">{item.uom || item.uomName || item.uomCode || "-"}</div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label text-muted small mb-1">Dashboard</label>
                                                    <div className="form-check form-switch mt-2">
                                                        <input
                                                            className="form-check-input cursor-pointer"
                                                            type="checkbox"
                                                            checked={item.isDashboard === 1 || item.isDashboard === true || item.userField1 === "1" || item.userField1 === 1}
                                                            onChange={(e) => handleDashboardToggle(item.itemId, e.target.checked)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label text-muted small mb-1">Min Shelf Qty</label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className="form-control"
                                                        value={item.minimumShelfQuantity}
                                                        onChange={(e) => handleQuantityChange(item.itemId, e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    /* Multi-item selection mode */
                                    <div className="card border rounded p-3 bg-light">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="d-flex align-items-center gap-2">
                                                <h6 className="fw-bold mb-0 text-dark">Category Items</h6>
                                                <span className="badge bg-primary rounded-pill px-3 py-1">
                                                    {selectedItems.length} Selected
                                                </span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                style={{ maxWidth: "280px" }}
                                                placeholder="🔍 Filter category items..."
                                                value={itemSearch}
                                                onChange={(e) => setItemSearch(e.target.value)}
                                            />
                                        </div>

                                        {(items || []).length === 0 ? (
                                            <div className="text-center py-4 text-muted bg-white border rounded">
                                                No items available under this category.
                                            </div>
                                        ) : (
                                            <div className="table-responsive bg-white border rounded" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                <table className="table table-hover table-striped mb-0 align-middle">
                                                    <thead className="table-light sticky-top" style={{ top: 0, zIndex: 1 }}>
                                                        <tr>
                                                            <th style={{ width: "130px" }}>
                                                                <div className="form-check mb-0">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input cursor-pointer"
                                                                        id="selectAllCheckbox"
                                                                        checked={isAllCategoryItemsSelected}
                                                                        onChange={handleToggleSelectAllCategoryItems}
                                                                    />
                                                                    <label className="form-check-label fw-bold cursor-pointer" htmlFor="selectAllCheckbox">
                                                                        Select All
                                                                    </label>
                                                                </div>
                                                            </th>
                                                            <th style={{ width: "160px" }}>Item Name</th>
                                                            <th>Item Description</th>
                                                            <th style={{ width: "90px" }}>UOM</th>
                                                            <th style={{ width: "140px" }}>Min Shelf Qty</th>
                                                            <th style={{ width: "110px" }} className="text-center">Dashboard</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {displayedCategoryItems.length > 0 ? (
                                                            displayedCategoryItems.map((it) => {
                                                                const selectedObj = selectedItems.find((s) => s.itemId === it.id);
                                                                const isChecked = !!selectedObj;
                                                                return (
                                                                    <tr key={it.id} className={isChecked ? "table-active" : ""}>
                                                                        <td>
                                                                            <div className="form-check mb-0">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input cursor-pointer"
                                                                                    checked={isChecked}
                                                                                    onChange={() => handleToggleSingleItem(it)}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        <td className="fw-semibold text-dark">{it.itemCode}</td>
                                                                        <td>{it.itemDescription}</td>
                                                                        <td>{it.uomName || it.uomCode || it.uom || "-"}</td>
                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                min="0"
                                                                                disabled={!isChecked}
                                                                                className="form-control form-control-sm"
                                                                                placeholder="0"
                                                                                value={selectedObj ? selectedObj.minimumShelfQuantity : 0}
                                                                                onChange={(e) => handleQuantityChange(it.id, e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <div className="form-check form-switch d-flex justify-content-center align-items-center mb-0">
                                                                                <input
                                                                                    className="form-check-input cursor-pointer"
                                                                                    type="checkbox"
                                                                                    disabled={!isChecked}
                                                                                    checked={selectedObj ? (selectedObj.isDashboard === 1 || selectedObj.isDashboard === true || selectedObj.userField1 === "1" || selectedObj.userField1 === 1) : false}
                                                                                    onChange={(e) => handleDashboardToggle(it.id, e.target.checked)}
                                                                                />
                                                                            </div>
                                                                        </td>

                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center py-3 text-muted">
                                                                    No items match your filter search.
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                )
                            ) : (
                                <div className="text-center py-4 border border-dashed rounded text-muted bg-light">
                                    Please select an <strong>Item Category</strong> above to view and choose items.
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div className="px-4 py-3 bg-light border-top d-flex justify-content-between align-items-center">
                            <span className="text-muted small">
                                {selectedItems.length > 0 ? `${selectedItems.length} item(s) ready to assign` : "No items selected"}
                            </span>
                            <div className="d-flex gap-2">
                                <button
                                    className="btn btn-outline-secondary px-4"
                                    onClick={() => {
                                        setShowModal(false);
                                        setEditData(null);
                                        setSelectedItems([]);
                                        setCategorySearch("");
                                        setItems([]);
                                        setItemSearch("");
                                        setValue("itemCategoryId", "");
                                        reset({ itemId: "" });
                                    }}
                                >
                                    Cancel
                                </button>

                                {(editData ? can("canModify") : can("canAdd")) && (
                                    <button className="btn btn-primary px-4" disabled={loading || (selectedItems.length === 0 && !editData)} onClick={handleSave}>
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" />
                                                {editData ? "Updating..." : "Saving..."}
                                            </>
                                        ) : editData ? (
                                            "Update Item"
                                        ) : (
                                            `Assign ${selectedItems.length > 0 ? `(${selectedItems.length}) Items` : "Items"}`
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
